import { AfterViewInit, Component, ElementRef, OnDestroy, Signal, WritableSignal } from '@angular/core';

@Component({
  template: ''
})
export abstract class BottomMenuObserverBaseComponent implements AfterViewInit, OnDestroy {
  private resizeObserver: ResizeObserver;

  protected abstract bottomMenu: Signal<ElementRef<HTMLElement> | undefined>;
  protected abstract bottomMenuHeight: WritableSignal<number>;

  ngAfterViewInit(): void {
    const el = this.bottomMenu()?.nativeElement;
    if (!el) {
      return;
    }

    this.bottomMenuHeight.set(el.offsetHeight);

    this.resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        if (entry.target === el) {
          const contentRect = entry.contentRect;
          const newHeight = contentRect.height + contentRect.x + contentRect.y;
          this.bottomMenuHeight.set(newHeight);
        }
      }
    });

    this.resizeObserver.observe(el);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }
}
